import React from 'react';

const ChallengeOpportunity = () => {
  return (
     <div class="faq_area bg_color2 pt-40 pb-25">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="section_title text_center mb-60 mt-3">
              <div class="section_main_title">
                <h1>The Challenge</h1>
              </div>
              <div class="em_bar">
                <div class="em_bar_bg"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-6 col-md-6">
            <div class="single_faq mb-4">
              <div class="single_faq_content">
                
                <div class="single_faq_text">
                 <div className="em-feature-title">
                 
                  
                  <ul className="feature-bullets ">
                    <li>● Fragmented tech stacks and legacy vendor lock-ins hindered scalability.</li>
                    <li>● Cloud maturity varied widely across target accounts.</li>
                    <li>● Buying behavior was inconsistent and hard to predict.</li>
                   <br/>
                  </ul>
                </div>

                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-md-6">
            <div class="single_faq mb-4">
              <div class="single_faq_content">
              
                <div class="single_faq_text">
                  <div className="em-feature-title">
                 
                  <ul className="feature-bullets ">
                    <li>● Traditional outreach lacked relevance and impact.</li>
                    <li>● No unified intelligence to identify decision-makers at the right time.</li>
                    <li>● Stakeholders were either too early, or already committed elsewhere.
                    </li>
                  </ul>
                </div>
                </div>
              </div>
            </div>
          </div>
         
          
          
          
        </div>
      </div>
    </div>
  );
};

export default ChallengeOpportunity;
